import React, { useEffect, useState } from "react";
import { AI_FIELDS } from "../lib/aiReview";
import { fieldStatus, STATUS_CLS } from "../lib/aiCompare";

const fmtDate = (iso) => (iso ? new Date(iso).toLocaleString("lt-LT") : "");
const nameOf = (it, i) => String(it.name?.value || `#${i + 1}`).trim();

// List of all analyses + side-by-side comparison of two analyses (matched by position name).
export function AiArchive({ list, load, t }) {
    const [a, setA] = useState(list[1]?.id || list[0]?.id);
    const [b, setB] = useState(list[0]?.id);
    const [data, setData] = useState({});
    useEffect(() => {
        Promise.all([a, b].filter(Boolean).map(load)).then((r) => setData(Object.fromEntries(r.map((x) => [x.id, x])))).catch(() => {});
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [a, b]);
    const A = data[a], B = data[b];
    const keys = A && B ? [...new Set([...A.items.map(nameOf), ...B.items.map(nameOf)])] : [];
    const find = (an, k) => an.items.find((it, i) => nameOf(it, i) === k);
    const sel = (v, set, id) => (
        <select data-testid={id} value={v || ""} onChange={(e) => set(e.target.value)} className="h-9 bg-[#0b0f17] border border-[#1e293b] rounded px-2 text-sm">
            {list.map((x) => <option key={x.id} value={x.id}>{fmtDate(x.created_at)} · {x.user_name} ({x.item_count})</option>)}
        </select>
    );
    return (
        <div className="space-y-3">
            <div className="overflow-auto max-h-48 border border-[#1e293b] rounded-md">
                <table data-testid="ah-archive-list" className="w-full text-sm">
                    <thead className="bg-[#0b0f17] text-[11px] font-mono uppercase text-slate-400">
                        <tr>{["ah_date", "ah_user", "ah_pdf_name", "ah_items", "ah_imported"].map((k) => <th key={k} className="px-2 py-1.5 text-left">{t(k)}</th>)}</tr>
                    </thead>
                    <tbody>
                        {list.map((x) => (
                            <tr key={x.id} data-testid={`ah-archive-${x.id}`} className="border-t border-[#182232]">
                                <td className="px-2 py-1 font-mono">{fmtDate(x.created_at)}</td><td className="px-2">{x.user_name}</td>
                                <td className="px-2 truncate max-w-xs">{x.pdf_filename || "—"}</td><td className="px-2 font-mono">{x.item_count}</td><td className="px-2 font-mono">{x.imported_count}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className="flex items-center gap-2 flex-wrap text-sm">{t("ah_compare_two")}: {sel(a, setA, "ah-cmp-a")} ↔ {sel(b, setB, "ah-cmp-b")}</div>
            {A && B && (
                <div className="overflow-auto max-h-[40vh] border border-[#1e293b] rounded-md">
                    <table data-testid="ah-cmp-table" className="text-sm border-collapse">
                        <thead className="sticky top-0 bg-[#0b0f17]">
                            <tr>{AI_FIELDS.map((f) => <th key={f.key} className="px-1.5 py-1.5 text-left text-[11px] font-mono uppercase text-slate-400 border-r border-[#1e293b] whitespace-nowrap">{t(`ai_f_${f.key}`)}</th>)}</tr>
                        </thead>
                        <tbody>
                            {keys.map((k) => {
                                const x = find(A, k), y = find(B, k);
                                return (
                                    <tr key={k} data-testid={`ah-cmp-row-${k}`} className="border-t border-[#182232]">
                                        {AI_FIELDS.map((f) => {
                                            const va = x?.[f.key]?.value ?? "", vb = y?.[f.key]?.value ?? "";
                                            const st = !x ? "manual" : !y ? "big" : fieldStatus(va, vb, f.num);
                                            return <td key={f.key} className={`px-1.5 py-1 font-mono border-r border-[#182232] ${STATUS_CLS[st]}`}>{String(va) || "—"} → {String(vb) || "—"}</td>;
                                        })}
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}
